module.exports = __webpack_public_path__ + "img/menu6.eed2a5f0.png";